import React, { createContext, useContext, useMemo } from 'react';
import detectRegion from '../config/region';

const RegionContext = createContext();

/**
 * RegionProvider - provides centralized region config to the entire app.
 * Region is determined once at app load based on hostname.
 */
export const RegionProvider = ({ children }) => {
  const region = useMemo(() => detectRegion(), []);

  return (
    <RegionContext.Provider value={region}>
      {children}
    </RegionContext.Provider>
  );
};

/**
 * useRegion hook - access the current region config from any component.
 * @returns {Object} Region config (code, countryCode, flag, phoneLength, etc.)
 */
export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export default RegionContext;
